var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vh-zalo-inbox"},[_c('zalo-inbox',{ref:"inbox"}),(_vm.loadError)?_c('div',{staticClass:"vh-zalo-inbox__error"},[_vm._v(_vm._s(_vm.loadError))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }